import { NgModule } from '@angular/core';
import {
  bootstrapApplication,
  BrowserModule,
  provideClientHydration,
} from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './components/header/header.component';
import { SigninComponent } from './components/signin/signin.component';
import { SignupComponent } from './components/signup/signup.component';
import { SliderComponent } from './components/slider/slider.component';
import { HomeComponent } from './components/home/home.component';
import { ToolbarComponent } from './components/toolbar/toolbar.component';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { HomePipe } from './home.pipe';
import { FooterComponent } from './components/footer/footer.component';
import { SpacailOfferComponent } from './components/spacail-offer/spacail-offer.component';
import { TopsellingProductComponent } from './components/topselling-product/topselling-product.component';
import { ProductBannerComponent } from './components/product-banner/product-banner.component';
import { ForgetPasswordComponent } from './components/forget-password/forget-password.component';
import { ProductListComponent } from './components/product-list/product-list.component';
import {
  CommonModule,
  NgSwitch,
  NgSwitchCase,
} from '@angular/common';
import { MyCartComponent } from './components/my-cart/my-cart.component';
import { PaymentOptionComponent } from './components/payment-option/payment-option.component';
import { OrderSumamaryComponent } from './components/order-sumamary/order-sumamary.component';
import { SellerProductPageComponent } from './components/seller-product-page/seller-product-page.component';
import { SellerProductAllProductComponent } from './components/seller-product-all-product/seller-product-all-product.component';
import { FiltersComponent } from './components/filters/filters.component';
import { StpesComponent } from './components/stpes/stpes.component';
import { AddAddressComponent } from './components/add-address/add-address.component';
import { ProfileDetailsComponent } from './components/profile-details/profile-details.component';
import { MyorderListComponent } from './components/myorder-list/myorder-list.component';
import { MyProfileComponent } from './components/my-profile/my-profile.component';
import { AllTransactionComponent } from './components/all-transaction/all-transaction.component';
import { MyWishlistComponent } from './components/my-wishlist/my-wishlist.component';
import { ReviewRatingComponent } from './components/review-rating/review-rating.component';
import { CouponsComponent } from './components/coupons/coupons.component';
import { ResetPasswaordComponent } from './components/reset-passwaord/reset-passwaord.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { ToastrModule } from 'ngx-toastr';
import { HttpClientModule } from '@angular/common/http';
import { NgOtpInputModule } from 'ng-otp-input';
import { OtpVerificationComponent } from './components/otp-verification/otp-verification.component';
import { MycartComponent } from './components/mycart/mycart.component';
import { RatingComponent } from './components/rating/rating.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MyModalComponent } from './components/my-modal/my-modal.component';
import { LoaderComponent } from './components/loader/loader.component';
import { TermsConditionsComponent } from './components/terms-conditions/terms-conditions.component';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy.component';
import { MyNotificationComponent } from './components/my-notification/my-notification.component';
import { ToTopComponent } from './components/to-top/to-top.component';
import { OrderDetailsComponent } from './components/order-details/order-details.component';
import { OrderCancelledComponent } from './components/order-cancelled/order-cancelled.component';
import { MyOrderCancelModelComponent } from './components/my-order-cancel-model/my-order-cancel-model.component';
import { OrderReturnComponent } from './components/order-return/order-return.component';
import { ExchangeOrderComponent } from './components/exchange-order/exchange-order.component';
import { HelpSupportComponent } from './components/help-support/help-support.component';
import { TicketRaisedModelComponent } from './components/ticket-raised-model/ticket-raised-model.component';
import { ReturnRefundModelComponent } from './components/return-refund-model/return-refund-model.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { DirectPurchaseComponent } from './components/direct-purchase/direct-purchase.component';
import { FiltersModalComponent } from './components/filters-modal/filters-modal.component';

import { PaymentFailComponent } from './components/payment-fail/payment-fail.component';
import { TicketRaisedChatComponent } from './components/ticket-raised-chat/ticket-raised-chat.component';
import { OrderTrackComponent } from './components/order-track/order-track.component';
import { CustomerFeedbackPageComponent } from './components/customer-feedback-page/customer-feedback-page.component';
import { LazyLoadDirective } from 'lazy-load.directive';
import { WalletComponent } from './components/wallet/wallet.component';
import { ProductModule } from './components/product/product.module';
import { AskQuestionModule } from './components/ask-question/ask-question.module';
import { FaqComponent } from './components/faq/faq.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    SigninComponent,
    SignupComponent,
    SliderComponent,
    HomeComponent,
    ToolbarComponent,
    HomePipe,
    FooterComponent,
    SpacailOfferComponent,
    TopsellingProductComponent,
    ProductBannerComponent,
    ForgetPasswordComponent,
    ProductListComponent,
    MyCartComponent,
    PaymentOptionComponent,
    OrderSumamaryComponent,
    SellerProductPageComponent,
    SellerProductAllProductComponent,
    FiltersComponent,
    StpesComponent,
    AddAddressComponent,
    ProfileDetailsComponent,
    MyorderListComponent,
    MyProfileComponent,
    AllTransactionComponent,
    MyWishlistComponent,
    ReviewRatingComponent,
    CouponsComponent,
    ResetPasswaordComponent,
    OtpVerificationComponent,
    MycartComponent,
    RatingComponent,
    MyModalComponent,
    LoaderComponent,
    TermsConditionsComponent,
    PrivacyPolicyComponent,
    MyNotificationComponent,
    ToTopComponent,
    OrderDetailsComponent,
    OrderCancelledComponent,
    MyOrderCancelModelComponent,
    OrderReturnComponent,
    ExchangeOrderComponent,
    HelpSupportComponent,
    TicketRaisedModelComponent,
    ReturnRefundModelComponent,
    PageNotFoundComponent,
    DirectPurchaseComponent,
    FiltersModalComponent,
    PaymentFailComponent,
    TicketRaisedChatComponent,
    OrderTrackComponent,
    CustomerFeedbackPageComponent,
    WalletComponent,
 LazyLoadDirective,
 FaqComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    FormsModule,
    BrowserModule,
    AppRoutingModule,
    CommonModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    ToastrModule.forRoot({
      positionClass: 'toast-top-center',
      timeOut: 2000,
    }),
    HttpClientModule,
    NgOtpInputModule,
    NgSwitch,
    NgSwitchCase,
    ProductModule,
    AskQuestionModule,
  ],
  providers: [
    provideClientHydration(),
    provideHttpClient(withFetch()), // Enable fetch API for HttpClient
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
